import ASLoader from 'components/asloader/ASLoader';
import { LoaderType } from 'components/asloader/ASLoader.types';
import React from 'react';
import { ASComponentSize } from 'types/App.types';

type SqLoaderProps = {
  className?: string;
  showLoader?: boolean;
};

const SqLoader: React.FC<SqLoaderProps> = ({ className = '', showLoader = true }) => {
  const baseCls = `${className}`;
  return (
    <ASLoader
      className={baseCls}
      loaderSize={ASComponentSize.Large}
      loaderType={LoaderType.Spin}
      showLoader={showLoader}
    />
  );
};

export default SqLoader;
